import { FC, useContext } from "react";
import classNames from "classnames";
import capitalize from "lodash/capitalize";
import { useSelector } from "react-redux";

import { useCheckoutContext } from "@contexts/checkout-context";

import CartCheckoutCta from "@components/store/cart/cart-checkout-cta";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { getReceivedItemsCount } from "@selectors/cart";

import { pluralizeWord } from "@stadium/helpers/string";

import styles from "./main.module.scss";

const PricelessShopCartContent: FC = () => {
  const receivedItemsCount = useSelector(getReceivedItemsCount);
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const { cartItemsQuantity } = useCheckoutContext();

  const processedItemsWord = pluralizeWord("item", { count: receivedItemsCount });
  const isSingluarItem = receivedItemsCount === 1;

  const renderSelectionMessage = () => {
    if (receivedItemsCount < +cartItemsQuantity) {
      return (
        <div className={styles.alertMsg}>
          <i className={styles.alertIcon} />
          <span>
            Please limit your bag to {receivedItemsCount} {processedItemsWord} to continue.
          </span>
        </div>
      );
    }
    if (receivedItemsCount > +cartItemsQuantity) {
      return (
        <div className={styles.normalMsg}>
          Add {isSingluarItem ? "an item" : "more items"} to continue.{" "}
          {capitalize(processedItemsWord)} {isSingluarItem ? "has" : "have"} been already paid for
          by the sender.
        </div>
      );
    }
    return (
      <div className={styles.successMsg}>
        <i className={styles.tickIcon} />
        <span>You've got great taste! Continue to checkout to make this selection yours.</span>
      </div>
    );
  };

  const redeemedItemsBarSectionArr = () =>
    Array(receivedItemsCount)
      .fill()
      .map((_, i) => (
        <div
          className={classNames(styles.stretchBox, {
            [styles.blueBg]: i < +cartItemsQuantity,
            [styles.leftBorderRadius]: i === 0,
            [styles.rightBorderRadius]: i === +cartItemsQuantity - 1,
          })}
          key={i}
        >
          &nbsp;
        </div>
      ));

  const renderCartCheckoutCta = () => {
    if (isMobileDevice) return null;
    return <CartCheckoutCta className={styles.fullButtonBlock} />;
  };

  return (
    <div className={styles.pricelessRightBlock}>
      <div
        className={`${styles.itemsNoHeading} ${
          +cartItemsQuantity > +receivedItemsCount ? styles.alertText : ""
        }`}
      >
        {cartItemsQuantity}/{receivedItemsCount} {processedItemsWord.toUpperCase()} SELECTED
      </div>
      <div className={styles.bar}>{redeemedItemsBarSectionArr()}</div>
      <div className={styles.largeHeading}>
        You've been gifted {receivedItemsCount} {processedItemsWord}
      </div>
      {renderSelectionMessage()}
      {renderCartCheckoutCta()}
    </div>
  );
};

export default PricelessShopCartContent;
